$(document).ready(function () {
    // Si le texte "L'identifiant est incorrect" présent alors affichage modale
    var showModal = $('.alert-danger').text();
    if (showModal) {
        $('#modal-pre-mire-connexion').modal();
    }
});
